'use client';

import React, { useEffect } from 'react';
import { CustomHtmlTile } from './types/CustomHtmlTile';

export default function CustomHtml({ tile }: { tile: CustomHtmlTile }) {
  const { html } = tile;

  // Extract the <script> tag and its content
  const scriptMatch = html?.text?.match(/<script.*?>([\s\S]*?)<\/script>/i);
  const scriptContent = scriptMatch?.[1]; // Extract the content inside the <script> tag
  const htmlWithoutScript = html?.text?.replace(/<script.*?>[\s\S]*?<\/script>/i, '') || '';

  useEffect(() => {
    if (scriptContent) {
      // Directly execute the script content
      try {
        const scriptFunction = new Function(scriptContent);
        scriptFunction();
      } catch (error) {
        console.error('Error executing script:', error);
      }
    }
  }, [scriptContent]);

  if (!html?.text) { return null; }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: htmlWithoutScript,
      }}
    />
  );
}
